import { LocalRoleTags } from 'const';
import { isArray } from 'lodash';
import { buildConfig, BuildMode } from 'packages/buildConfig';
import { IUserFunctionality } from 'types';

// 96926857 - номер счетчика яндекс метрики для тестового стенда
const TEST_METRIKA_COUNTER = 96926857;

export const getYandexMetrikaCode = (user: IUserFunctionality, localRoles: string[], mode?: BuildMode): number[] => {
  const configAccounts = buildConfig.config?.YANDEX_METRIKA?.accounts;
  const defaultValue = [0];

  if (!configAccounts) return defaultValue;

  let accounts: number[] | undefined;

  // сначала проверяется локальная роль
  if (localRoles.includes(LocalRoleTags.employeeOo)) accounts = configAccounts.employee_o_o;
  else if (localRoles.includes(LocalRoleTags.adminOo)) accounts = configAccounts.admin_o_o;

  if (!accounts) {
    // используем функционал пользователя, если не найдены совпадения по локальной роли
    if (user.isStudent) accounts = configAccounts.student;
    else if (user.isParent) accounts = configAccounts.parent;
    else if (user.isOperator || user.isEmployee) accounts = configAccounts.employee;
  }

  if (accounts && (mode === 'DEV' || mode === 'TEST') && !accounts?.includes(TEST_METRIKA_COUNTER)) {
    accounts = [...accounts, TEST_METRIKA_COUNTER];
  }

  return isArray(accounts) ? accounts : defaultValue;
};
